// document.getElementById("womensTab").style.display ="none";

// document.getElementById("womensPrefferedFitTab").style.display ="none";

document.getElementById("mensTabBtn").style.color = "black";
document.getElementById("mensTabBtn").style.borderColor = "black";

document.getElementById("mensSizeTables").style.display ="block";
// document.getElementById("womensSizeTables").style.display ="none";

document.getElementById("mensMeasureTab").style.display ="block";
// document.getElementById("womensMeasureTab").style.display ="none";


function showMensTab() {

    console.log("happy 1");
  document.getElementById("womensTab").style.display ="none"
  document.getElementById("womensTabBtn").style.color = "#696969";
  document.getElementById("womensTabBtn").style.borderColor = "white";
   document.getElementById("mensTabBtn").style.color = "black";
  
  document.getElementById("mensTab").style.display ="flex";
  document.getElementById("mensTabBtn").style.borderColor = "black";
 
  document.getElementById("womensPrefferedFitTab").style.display ="none";  
  document.getElementById("mensPrefferedFitTab").style.display ="flex";

document.getElementById("mensSizeTables").style.display ="block";
document.getElementById("womensSizeTables").style.display ="none";

document.getElementById("mensMeasureTab").style.display ="block";
document.getElementById("womensMeasureTab").style.display ="none";
}
function showWomensTab() {

  console.log("happy 2");
  document.getElementById("mensTab").style.display ="none";
  document.getElementById("mensTabBtn").style.borderColor = "white";

  document.getElementById("womensTabBtn").style.color = "black";
   document.getElementById("mensTabBtn").style.color = "#696969";
  
  document.getElementById("womensTab").style.display ="flex";
  document.getElementById("womensTabBtn").style.borderColor = "black";

  document.getElementById("mensPrefferedFitTab").style.display ="none";
  document.getElementById("womensPrefferedFitTab").style.display ="flex";

  document.getElementById("mensSizeTables").style.display ="none";
  document.getElementById("womensSizeTables").style.display ="block";

  document.getElementById("womensMeasureTab").style.display ="block";
  document.getElementById("mensMeasureTab").style.display ="none";
}



document.getElementById("mensTabBtn").onclick = function() {showMensTab()};
// document.getElementById("womensTabBtn").onclick = function() {showWomensTab()};



// /* working shirt wear size table functionality */
document.getElementById("mensDressShirtTab").style.display ="flex";
document.getElementById("mensCasualShirtTab").style.display = "none";
document.getElementById("mensShirtJacketTab").style.display = "none";
document.getElementById("mensSweatshirtTab").style.display = "none";
document.getElementById("mensHenleyTab").style.display = "none";
document.getElementById("mensPoloTab").style.display = "none";
document.getElementById("mensShortsTab").style.display = "none";
document.getElementById("mensLightJacketTab").style.display = "none";


document.getElementById("mensDressShirtTabBtn").style.color = "black";
document.getElementById("mensDressShirtTabBtn").style.borderColor = "black";

function hideAllMenSizeTables() {
    // List of all size tab IDs
    const sizeTabIds = [
        "mensDressShirtTab",
        "mensCasualShirtTab",
        "mensShirtJacketTab",
        "mensLightJacketTab",
        "mensSweatshirtTab",
        "mensHenleyTab",
        "mensPoloTab",
        "mensShortsTab"
    ];

    
    // Hide all size tables
    sizeTabIds.forEach(id => {
        document.getElementById(id).style.display = "none";
    });
}

function showMenSizeTable(tabId, buttonId) {
    // Hide all size tables
    hideAllMenSizeTables();
    
    // Show the specified size table
    const sizeTable = document.getElementById(tabId);
    sizeTable.style.display = "flex";

    // Update button styles
    const buttonIds = [
        "mensDressShirtTabBtn",
        "mensCasualShirtTabBtn",
        "mensShirtJacketTabBtn",
        "mensLightJacketTabBtn",
        "mensSweatshirtTabBtn",
        "mensHenleyTabBtn",
        "mensPoloTabBtn",
        "mensShortsTabBtn"
    ];

    buttonIds.forEach(id => {
        document.getElementById(id).style.color = "#696969"; // Default color for all buttons
        document.getElementById(id).style.borderColor = "white"; // Default border color for all buttons
    });

    // Highlight the active button
    document.getElementById(buttonId).style.color = "black";
    document.getElementById(buttonId).style.borderColor = "black";
}

// Example usage:
function showDressShirtSizeTable() {
    showMenSizeTable("mensDressShirtTab", "mensDressShirtTabBtn");
}
function showCasualShirtSizeTable() {
    showMenSizeTable("mensCasualShirtTab", "mensCasualShirtTabBtn");
}

function showShirtJacketSizeTable() {
    showMenSizeTable("mensShirtJacketTab", "mensShirtJacketTabBtn");
}

function showLightJacketSizeTable() {
    showMenSizeTable("mensLightJacketTab", "mensLightJacketTabBtn");
}

function showMenSweatshirtSizeTable() {
    showMenSizeTable("mensSweatshirtTab", "mensSweatshirtTabBtn");
}

function showHenleySizeTable() {
    showMenSizeTable("mensHenleyTab", "mensHenleyTabBtn");
}

function showPoloSizeTable() {
    showMenSizeTable("mensPoloTab", "mensPoloTabBtn");
}

function showShortsSizeTable() {
    showMenSizeTable("mensShortsTab", "mensShortsTabBtn");
}

document.getElementById("mensDressShirtTabBtn").onclick = function() {showDressShirtSizeTable()};
document.getElementById("mensCasualShirtTabBtn").onclick = function() {showCasualShirtSizeTable()};
document.getElementById("mensShirtJacketTabBtn").onclick = function() {showShirtJacketSizeTable()};
document.getElementById("mensLightJacketTabBtn").onclick = function() {showLightJacketSizeTable()};
document.getElementById("mensSweatshirtTabBtn").onclick = function() {showMenSweatshirtSizeTable()};
document.getElementById("mensHenleyTabBtn").onclick = function() {showHenleySizeTable()};
document.getElementById("mensPoloTabBtn").onclick = function() {showPoloSizeTable()};
document.getElementById("mensShortsTabBtn").onclick = function() {showShortsSizeTable()};














// /* working shirt wear size table functionality for womens */
document.getElementById("womensHoodieTab").style.display = "flex";
document.getElementById("womensSweatshirtTab").style.display = "none";
document.getElementById("womensJoggersTab").style.display = "none";
document.getElementById("womensEverydayShirtTab").style.display = "none";
document.getElementById("womensOversizedTShirtTab").style.display = "none";
document.getElementById("womensPajamaPantsSetTab").style.display = "none";
document.getElementById("womensPajamaShortsSetTab").style.display = "none";

document.getElementById("womensHoodieTabBtn").style.color = "black";
document.getElementById("womensHoodieTabBtn").style.borderColor = "black";


function hideAllWomenSizeTables() {
    // List of all size tab IDs
    const sizeTabIds = [
    "womensHoodieTab",
    "womensSweatshirtTab",
    "womensJoggersTab",
    "womensEverydayShirtTab",
    "womensOversizedTShirtTab",
    "womensPajamaPantsSetTab",
    "womensPajamaShortsSetTab"
]


    
    // Hide all size tables
    sizeTabIds.forEach(id => {
        document.getElementById(id).style.display = "none";
    });
}

function showWomenSizeTable(tabId, buttonId) {
    // Hide all size tables
    hideAllWomenSizeTables();
    
    // Show the specified size table
    const sizeTable = document.getElementById(tabId);
    sizeTable.style.display = "flex";

    // Update button styles
    const buttonIds = [
    "womensHoodieTabBtn",
    "womensSweatshirtTabBtn",
    "womensJoggersTabBtn",
    "womensEverydayShirtTabBtn",
    "womensOversizedTShirtTabBtn",
    "womensPajamaPantsSetTabBtn",
    "womensPajamaShortsSetTabBtn"
]

    buttonIds.forEach(id => {
        document.getElementById(id).style.color = "#696969"; // Default color for all buttons
        document.getElementById(id).style.borderColor = "white"; // Default border color for all buttons
    });

    // Highlight the active button
    document.getElementById(buttonId).style.color = "black";
    document.getElementById(buttonId).style.borderColor = "black";
}


function showHoodieSizeTable() {
    showWomenSizeTable("womensHoodieTab", "womensHoodieTabBtn");
}

function showSweatshirtSizeTable() {
    showWomenSizeTable("womensSweatshirtTab", "womensSweatshirtTabBtn");
}

function showJoggersSizeTable() {
    showWomenSizeTable("womensJoggersTab", "womensJoggersTabBtn");
}

function showEverydayShirtSizeTable() {
    showWomenSizeTable("womensEverydayShirtTab", "womensEverydayShirtTabBtn");
}

function showOversizedTShirtSizeTable() {
    showWomenSizeTable("womensOversizedTShirtTab", "womensOversizedTShirtTabBtn");
}

function showPajamaPantsSetSizeTable() {
    showWomenSizeTable("womensPajamaPantsSetTab", "womensPajamaPantsSetTabBtn");
}

function showPajamaShortsSetSizeTable() {
    showWomenSizeTable("womensPajamaShortsSetTab", "womensPajamaShortsSetTabBtn");
}


document.getElementById("womensHoodieTabBtn").onclick = function() { showHoodieSizeTable(); };
document.getElementById("womensSweatshirtTabBtn").onclick = function() { showSweatshirtSizeTable(); };
document.getElementById("womensJoggersTabBtn").onclick = function() { showJoggersSizeTable(); };
document.getElementById("womensEverydayShirtTabBtn").onclick = function() { showEverydayShirtSizeTable(); };
document.getElementById("womensOversizedTShirtTabBtn").onclick = function() { showOversizedTShirtSizeTable(); };
document.getElementById("womensPajamaPantsSetTabBtn").onclick = function() { showPajamaPantsSetSizeTable(); };
document.getElementById("womensPajamaShortsSetTabBtn").onclick = function() { showPajamaShortsSetSizeTable(); };


